import React from 'react'
import Flag from 'components/Flag'
import PropTypes from 'prop-types'

export const CurrencyItem = ({ currency: { flag, name, abbreviature }, mode }) => {
	return <div className='c-currency-item'>
		<Flag className='u-margin-right-small' src={flag} alt={name} isCrypto={mode === 'crypto'} />
		<span className='c-currency-item__title'>
			<span className='u-text--normal'>{name}</span>
			<span className='u-text--normal u-weight--semi-bold'>{abbreviature}</span>
		</span>
	</div>
}

CurrencyItem.propTypes = {
	currency: PropTypes.shape({
		flag: PropTypes.string,
		name: PropTypes.string,
		abbreviature: PropTypes.string
	}),
	mode: PropTypes.string
}

export default CurrencyItem
